import { render, staticRenderFns } from "./WalletToWalletTransfer.vue?vue&type=template&id=03f876f8"
import script from "./WalletToWalletTransfer.vue?vue&type=script&lang=js"
export * from "./WalletToWalletTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports